<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="06" :question="question" @activateModal="modalActive=true" :modalActivator="true" :modalActive="modalActive"></QuestionTitle>
        <div class="container-70 mt-20px">
            <AlimentationCalculator v-model="results" :description="description"></AlimentationCalculator>
            <div  v-if="results!=null" @click="saveAndContinue('citoyenAlimentation', JSON.stringify(results), './question-7')" class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine  percent="60%" class="mt-50px"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <h3 class="modal-title">GES émis par votre alimentation</h3>
            <p class="modal-text">La production des protéines animales émet nettement plus de GES que celle des protéines végétales, notamment parce qu'elle nécessite plus de terres agricoles et plus d'eau. Parmi les protéines animales, les ruminants ont le plus grand impact environnemental, car ils relâchent du méthane dans l'atmosphère lors de leur digestion, soit un gaz 28 fois plus néfaste que le CO2. Cette section permet d'estimer l'impact environnemental de vos habitudes alimentaires selon le type de protéine que vous privilégiez.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import ModalInfo from '@/components/ModalInfo.vue'
import AlimentationCalculator from '@/components/AlimentationCalculator.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default{
    data(){
        return {
            results:null,
            question: 'Indiquez les proportions qui représentent le mieux l\'alimentation de votre ménage pour une semaine normale.',
            modalActive:false,
            description:"Par exemple, si toutes les personnes dans le ménage sont omnivores, c'est 100 % omnivore. Si un couple est composé d'une personne consommatrice de viande et d'une personne végétarienne, ce sera : viande à tous les repas 50 % et végétarien 50 %."
        }
    },
    components:{
        QuestionTitle,
        ModalInfo,
        AlimentationCalculator,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('citoyenAlimentation')){
            this.results=JSON.parse(sessionStorage.getItem('citoyenAlimentation'))
        }
    }
}
</script>